// extracted by mini-css-extract-plugin
module.exports = {"container":"Icon_container__6WLaL","clickable":"Icon_clickable__tR_ye"};